import axios from "axios";
import { K2ACCOUNTS_BASE_URL } from "./Baseurl";

const K2AccountsApi = axios.create({
  baseURL: K2ACCOUNTS_BASE_URL,
});

export default K2AccountsApi;
